import React from 'react';
import { TableDataSortCase } from '../../../../../../store/deals/deals.types';
import { DealsTableHeaderTooltip } from '../../headerTooltip/DealsTableHeaderTooltip';
import { TableSortChevron } from '../Chevron/SortChevron';

type Props = {
  changeSortCase: () => void;
  dataSortCase: TableDataSortCase;
};

export const LastInteraction: React.FC<Props> = ({
  changeSortCase,
  dataSortCase,
}) => {
  const clickSort = () => {
    changeSortCase();
  };

  const attrs = {
    wrapper: {
      className: 'table-header-last-interaction',
    },

    title: {
      className: 'table-header-last-interaction-title',
    },

    tooltip: {
      text: `This shows the time that passed since the last interaction. 
      It is based on Gmail's API and may take for some time to refresh. 
      The most updated information is found in the engagement view.`,
      width: '210px',
      isLastInteraction: true,
    },

    sortSection: {
      wrapper: {
        className: 'table-header-last-interaction__sort-section',
        onClick: clickSort,
      },

      ChevronBA: {
        activeCase: '9-1' as TableDataSortCase,
        currentCase: dataSortCase,
      },

      ChevronAB: {
        activeCase: '1-9' as TableDataSortCase,
        currentCase: dataSortCase,
        rotated: true,
      },
    },
  };

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.title}>Last Interaction</div>
      <DealsTableHeaderTooltip {...attrs.tooltip} />
      <div {...attrs.sortSection.wrapper}>
        <TableSortChevron {...attrs.sortSection.ChevronBA} />
        <TableSortChevron {...attrs.sortSection.ChevronAB} />
      </div>
    </div>
  );
};
